import React from 'react';

type OrganizationCardProps = {
    name: string;
    location: string;
    status?: 'active' | 'inactive' | 'expiring' | 'underperforming';
    isPremium?: boolean;
    isStandard?: boolean;
    staffCount: number;
    venueCount: number;
    averageRating: number;
};

const OrganizationCard: React.FC<OrganizationCardProps> = ({
    name,
    location,
    status = 'active',
    isPremium,
    isStandard,
    staffCount,
    venueCount,
    averageRating,
}) => {
    // Define dot color based on status
    const getDotColor = () => {
        switch (status) {
            case 'active':
                return 'green';
            case 'expiring':
                return 'orange';
            case 'underperforming':
                return 'red';
            default:
                return 'gray';
        }
    };

    return (
        <div className="org-card">
            <div className="org-card-header">
                <div className="org-name-section">
                    <div className={`org-dot ${getDotColor()}`}></div>
                    <h3 className="org-name">{name}</h3>
                </div>
                <div className="org-badge-container">
                    {isPremium && <span className="org-badge premium">Premium</span>}
                    {isStandard && <span className="org-badge standard">Standard</span>}
                </div>
            </div>

            <div className="org-card-body">
                <div className="org-location">
                    <i className="pi pi-map-marker"></i>
                    <span>{location}</span>
                </div>

                <div className="org-stats-container">
                    <div className="org-stat-row">
                        <div className="org-stat-icon">
                            <i className="pi pi-users"></i>
                        </div>
                        <div className="org-stat-label">Staff Count</div>
                        <div className="org-stat-value">{staffCount}</div>
                    </div>

                    <div className="org-stat-row">
                        <div className="org-stat-icon">
                            <i className="pi pi-building"></i>
                        </div>
                        <div className="org-stat-label">Venues</div>
                        <div className="org-stat-value">{venueCount}</div>
                    </div>

                    <div className="org-stat-row">
                        <div className="org-stat-icon">
                            <i className="pi pi-star"></i>
                        </div>
                        <div className="org-stat-label">Average Rating</div>
                        <div className="org-stat-value">{averageRating.toFixed(1)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrganizationCard;
